import { render, staticRenderFns } from "./EditTDS.vue?vue&type=template&id=f7feec64&"
import script from "./EditTDS.vue?vue&type=script&lang=js&"
export * from "./EditTDS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports